export default __webpack_public_path__ + "static/media/new-dashboard.36a9ca60.png";